<template>
  <li class="video-thumbnail col mb2" :class="getThumbnailClass">
    <router-link :to="getLink()">
      <div class="pb3 relative">
        <div class="video-thumbnail-image" v-lazy:background-image="imgUrl"></div>
        <div v-if="isActive" class="video-now-playing absolute z1 flex items-center"></div>
        <span class="video-length absolute font-size-small">{{ getVideoTimeFromSeconds(video.duration) }}</span>
        <h3 class="video-title-short pr3 mt1 mb0">{{ video.title }}</h3>
        <div class="video-channel">
          <span v-if="video.hasOwnProperty('channels') && video.channels !== null">
            <span v-if="isActive" :class="{ green: isActive }">●</span>
            <span v-if="(this.$route.name === 'Channels' || this.$route.name === 'Subchannel') && video.channels.hasOwnProperty(this.$route.params.slug)">
              <span>{{ this.$route.params.slug }}</span>
              <span v-if="this.$route.params.slug !== video.channels[this.$route.params.slug].join()">
                <span :class="{ green: isActive }">➔</span> {{ video.channels[this.$route.params.slug].join().split('-').join(' ') }}
              </span>
            </span>
            <span v-else>
              {{ Object.keys(video.channels)[0] }}
              <span v-if="Object.keys(video.channels)[0] !== video.channels[Object.keys(video.channels)[0]].join()"><span :class="{ green: isActive }">➔</span> {{ video.channels[Object.keys(video.channels)[0]].join().replace('-', ' ') }}</span>
            </span>
          </span>
          <span v-else>
            <span v-if="video.hasOwnProperty('themes') && video.themes">
              <span :class="{ green: isActive }">■</span>
              {{ video.themes[0].name }}
            </span>
          </span>

        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
import { mapState } from 'vuex'
import { getVideoTimeFromSeconds } from '../utils'

export default {

  name: 'VideoThumbnail',

  data () {
    return {
      windowWidth: window.innerWidth
    }
  },

  props: ['video', 'showSidebar'],

  computed: {
    ...mapState([
      'currentVideo'
    ]),
    isActive: function () {
      if (this.currentVideo !== null) {
        return this.video.id === this.currentVideo.id
      } else {
        return false
      }
    },
    imgUrl: function () {
      return this.video.image_small
    },
    thumbnailImageStyle: function () {
      return {
        backgroundImage: 'url(' + this.video.image_small + ')'
        // background: 'rgb(100,100,100)'
      }
    },
    getThumbnailClass () {
      if (this.showSidebar) {
        return ['col-12', 'lg-col-6']
      } else {
        return ['col-12', 'sm-col-4', 'lg-col-4']
      }
    }
  },

  methods: {
    getVideoTimeFromSeconds,
    getLink () {
      if (this.$route.name === 'Videos') {
        return `/videos/${this.video.slug}`
      } else {
        return `#${this.video.slug}`
      }
    }
  }
}
</script>

<style lang="css" scoped>
  li.video-thumbnail {
    cursor: pointer;
    padding-left: 0.15rem;
    padding-right: 0.15rem;

    a {
      color: var(--color-light);
      text-decoration: none;
    }

    &:hover, a.router-link-exact-active {
      .video-channel {
        opacity: 1;
      }
    }

    .video-title-short {
      padding-bottom: 1px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      /*! autoprefixer: on */
    }

    .video-channel {
      text-transform: uppercase;
      opacity: 0.15;
    }

    .video-length {
      top: 8px;
      left: 8px;
      padding: 4px;
      background: rgba(26,26,26,0.7);
      border-radius: 5px;
    }

    .video-thumbnail-image, .video-now-playing {
      width: 100%;
      padding-top: 56.25%;
      background-size: cover;
      background-position: center;
      background-color: rgba(255,255,255,0.1);
    }

    .video-now-playing {
      top: 0;
      left: 0;
      width: 100%;
      padding-top: 56.3%;
      background-color: rgba(16,255,0, 0.3);
      pointer-events: none;
    }

    div.video-thumbnail-image [lazy='loaded'] {
      opacity: 0;
      animation-name: fadein;
      animation-duration: .5s;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
      animation-direction: normal;
      animation-timing-function: ease-out;
      @keyframes fadein {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VideoThumbnail.vue